import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import CryptoJS from "crypto-js";
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from './utils/getCookie';
import ImageModalEquip from './Modal/ImageModalProd';
import { decryptToken } from './utils/getToken';
// import decryptUserCookie from './utils/decryptUserCookie';

const CategoryModal = ({ isOpen, setIsOpen, selectedCategory, setSelectedCategory, onSave, categories, setCategories, fetchCategories }) => {
    const [categoryName, setCategoryName] = useState('');
    const [position, setPosition] = useState('');
    const [status, setStatus] = useState(null);
    const [icon, setIcon] = useState("")
    const urlmain = process.env.REACT_APP_LINK
    const [images, setImages] = useState([]);
    const [parentBrand, setParentBrand] = useState(null);
    const [showImageModal, setShowImageModal] = useState(false);
    const [loadButton, setLoadButton] = useState(false);
    // const userDetails = decryptUserCookie();
    const userDetails = getDecryptedUserFromCookie("gta_mainstateuser");
    const token = decryptToken("accessToken") || ""

    const fetchImages = async () => {
        try {
            const res = await fetch(`${urlmain}/api/images/${userDetails.main_id}`);
            const data = await res.json();
            setImages(data);
        } catch (error) {
            console.error(error);
        }
    };


    const handleImageSelect = (field, img) => {
        setIcon(`${urlmain}${img.url}`);
    };

    useEffect(() => {
        fetchImages();
    }, []);


    useEffect(() => {
        if (selectedCategory) {
            setCategoryName(selectedCategory.category);
            setPosition(selectedCategory.position);
            setIcon(selectedCategory.icon);
            setParentBrand(parentBrandOptions.find(p => p.value === selectedCategory.category_id) || null);
            setStatus({ value: selectedCategory.status, label: selectedCategory.status });
        } else {
            setCategoryName('');
            setPosition('');
            setParentBrand(null);
            setIcon('');
            setStatus(null);
        }
    }, [selectedCategory]);


    const [categoriesMain, setCategoriesMain] = useState([]);

    const fetchBrand = async () => {
        try {
            const response = await fetch(`${urlmain}/category/getcategory`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            const res = await response.json();
            setCategoriesMain(res);

        } catch (error) {
            console.error(error)
        }
    }
    // Select options
    const brandOptions = categoriesMain.map(cat => {
        const parent = categoriesMain.find(c => c.id === cat.parentId);
        return {
            value: cat.id,
            label: parent ? `— ${cat.category}` : cat.category,
        };
    });


    const parentBrandOptions = [{ value: "", label: "None (Top-level)" }, ...brandOptions];


    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];


    const handleSubmit = async (e) => {
        setLoadButton(true);
        e.preventDefault();

        const categoryData = {
            category: categoryName,
            status: status?.value,
            position,
            category_id: parentBrand?.value || null,
            icon,
            main_id: userDetails.main_id,
            main_name: userDetails.full_name || 'Admin'
        };

        const isEdit = !!selectedCategory?.id;
        const url = isEdit
            ? `${urlmain}/category/update/${selectedCategory.id}`
            : `${urlmain}/category/addcategory/admin1997`;
        const method = isEdit ? "PUT" : "POST";

        try {
            const response = await fetch(url, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(categoryData),
            });

            const res = await response.json();
            if (response.ok) {
                setCategories(prev =>
                    isEdit
                        ? prev.map(cat => cat.id === selectedCategory.id ? { ...categoryData, id: selectedCategory.id } : cat)
                        : [...prev, { ...categoryData, id: res.id }]
                );
                toast.success(isEdit ? "Category updated" : "Category added");
                setIsOpen(false);
                setSelectedCategory(null);
                if (!isEdit) {
                    fetchCategories();
                }
            } else {
                toast.error(res.message || "Operation failed");
            }
        } catch (error) {
            console.error("Error submitting category:", error);
            toast.error("Unexpected error occurred");
        } finally{
            setLoadButton(false);
        }
    };

    useEffect(() => {
        fetchBrand();
    }, [])


    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" >
            <div
                className="custom-modal-content"

            >
                <h2 className="oms-modal-title">Category details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="categoryName" className="oms-form-label">
                            Category Name
                        </label>
                        <input
                            type="text"
                            id="categoryName"
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                            placeholder="Enter category name"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="position" className="oms-form-label">
                            Position
                        </label>
                        <input
                            type="text"
                            id="position"
                            value={position}
                            onChange={(e) => setPosition(e.target.value)}
                            placeholder="Enter position"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="parentBrand" className="oms-form-label">Parent Category</label>
                        <Select
                            id="parentBrand"
                            options={parentBrandOptions}
                            value={parentBrand}
                            onChange={setParentBrand}
                            placeholder="Select parent Category"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="position" className="oms-form-label">
                            Image
                        </label>
                        <button type="button" onClick={() => setShowImageModal(true)}>
                            Choose Image
                        </button>
                        <div>
                            {icon && (
                                <img src={icon} alt="Selected" style={{ width: 80, marginTop: 10 }} />
                            )}
                        </div>
                    </div>
                    <ImageModalEquip
                        show={showImageModal}
                        handleClose={() => setShowImageModal(false)}
                        images={images}
                        onImageSelect={(img) => handleImageSelect('image', img)}
                        multiple={false}
                        setImages={setImages}
                    />
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select
                            id="status"
                            options={statusOptions}
                            value={status}
                            onChange={setStatus}
                            placeholder="Select status"
                        />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        {
                            loadButton ? <button type="button">Submiting...</button> :
                                <button type="submit">Submit</button>
                        }

                    </div>
                </form>
            </div>
        </div>
    );
};

export default CategoryModal;
